import React from "react";
import ReactSelect, {components} from "react-select";
import {clearZero} from "../../functions/index";
import {CountryCode, CountryImages } from "../../Utils/Constants";
import "./index.css";

const countryCodeOptions = [...new Set(Object.values(CountryCode))].map(countrycode=>Object({value:countrycode,label:countrycode}));

const Option = props => {
  const {data} = props;
  return (
    <components.Option {...props} >
      <img src={CountryImages[data.label]} width="25" height="25" />
      {data.label}
    </components.Option>
  );
};

class AddCommunityMemberModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      firstname: "",
      phonenumber: "",
      phoneAppendix: {
        value: "+44",
        label: "+44",
      },
      countryCode: { value: "+44", label: "+44" },
    };
  }

  handlePhoneAppendix = (newValue) => {
    this.setState({
      phoneAppendix: newValue,
    });
  };

  onChangeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  addUser = () => {
    const { firstname, phonenumber, countryCode } = this.state;
    const { addUser } = this.props;
    console.log("phonenumber",`${countryCode.value}${clearZero(phonenumber)}`);
    addUser(firstname, `${countryCode.value}${clearZero(phonenumber)}`);
  };
  handleCountryCode = (countryCode) => {
    this.setState({ countryCode });
  };
  render() {
    const { firstname, phonenumber, countryCode } = this.state;
    return (
      <div
        className="modal fade"
        id="add_community_member"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Community Member</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control form-control-lg form-control-alt"
                  id="signup-username"
                  name="firstname"
                  placeholder="First Name"
                  onChange={this.onChangeHandler}
                  value={firstname}
                />
              </div>
              <div className="invite-user-phone-group">
                <div className="form-group phone-appendix">
                  {/* <Select
                    value={phoneAppendix}
                    onChange={this.handlePhoneAppendix}
                    options={[
                      {
                        value: "+44",
                        label: "+44",
                      },
                      {
                        value: "+1",
                        label: "+1",
                      },
                    ]}
                  /> */}
                  <ReactSelect
                    value={countryCode}
                    onChange={this.handleCountryCode}
                    options={countryCodeOptions}
                    styles={{
                      control: (styles) => ({
                        ...styles,
                        backgroundColor: "white",
                        width: 80,
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        display:"flex",
                        flexDirection:"row"
                      }),
                    }}
                    components={{Option}}
                  />
                </div>
                <div className="form-group phone-number">
                  <input
                    type="number"
                    className="form-control form-control-lg form-control-alt"
                    id="signup-email"
                    name="phonenumber"
                    placeholder="Phone Number"
                    onChange={this.onChangeHandler}
                    value={phonenumber}
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-light"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-sm btn-success"
                data-dismiss="modal"
                onClick={this.addUser}
              >
                Invite
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddCommunityMemberModal;



// WEBPACK FOOTER //
// ./src/components/AddCommunityMemberModal/index.js